module.exports = __webpack_public_path__ + "img/apple-store.095703b8.svg";